import {axios as http} from "@/plugins/http"

export default class Api {
    static tags() {
        return http.post("/api/v1/post/tags").then((resp) => {
            return resp.data?.items ?? []
        })
    }

    static delete(tagId, tagIdRedirect) {
        let config = {
            params: {
                tag_id: tagIdRedirect,
                tag_id_redirect: tagId,
            },
        }

        return http.get("/api/v1/post/site/tags/delete", config);
    }
}
